import { TableColumn as TableColumnWSR } from '@wix/design-system/dist/types/Table';
import { ActionCell } from '../ActionCell';
import { FiltersMap } from '@wix/bex-core';

interface ActionCellPropsType<T>
  extends Partial<Omit<TableColumnWSR<T>, 'render' | 'style'>> {}

export interface CollectionTableActionCellProps<T, F extends FiltersMap> {
  /**
   * Use this property to add an action at the end of each row. For example, a delete button to delete a table item.
   * Accepts an [`ActionCellProps`](./?path=/story/features-actions-action-cell--actioncellprops) object, or a function that returns an `ActionCellProps` object.
   * @external
   */
  actionCell?: ActionCell<T, F>;
  /**
   * Width of the column containing the `actionCell` component.
   *
   * @external
   */
  actionCellWidth?: string | number;
  /**
   * Extra columns props for the actions cell.
   */
  actionCellProps?: ActionCellPropsType<T>;
}
